module.exports = __webpack_public_path__ + "img/letterboxd.9a1591d3.png";